import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Shield, Loader2, Lock } from 'lucide-react';

function SuperAdminLoginForm({ loginData, onChange, onSubmit, loading }) {
    return (
        <div className="min-h-screen bg-background flex items-center justify-center p-6">
            <Card className="w-full max-w-md bg-gray-800 border-border">
                <CardHeader className="text-center">
                    <div className="w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center mx-auto mb-4">
                        <Shield className="w-8 h-8 text-primary" />
                    </div>
                    <CardTitle className="text-foreground">Super Admin</CardTitle>
                    <CardDescription className="text-muted-foreground">
                        Panel d'administration Homly
                    </CardDescription>
                </CardHeader>
                <CardContent>
                    <form onSubmit={onSubmit} className="space-y-4">
                        <div>
                            <Label className="text-foreground">Email</Label>
                            <Input
                                type="email"
                                value={loginData.email}
                                onChange={(e) => onChange({ ...loginData, email: e.target.value })}
                                className="bg-gray-700 border-gray-600 text-white"
                                placeholder="superadmin@homly.pro"
                                data-testid="superadmin-email"
                            />
                        </div>
                        <div>
                            <Label className="text-foreground">Mot de passe</Label>
                            <Input
                                type="password"
                                value={loginData.password}
                                onChange={(e) => onChange({ ...loginData, password: e.target.value })}
                                className="bg-gray-700 border-gray-600 text-white"
                                placeholder="••••••••"
                                data-testid="superadmin-password"
                            />
                        </div>
                        <Button type="submit" className="w-full" disabled={loading} data-testid="superadmin-login">
                            {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Lock className="w-4 h-4 mr-2" />}
                            Connexion
                        </Button>
                    </form>
                </CardContent>
            </Card>
        </div>
    );
}

export default SuperAdminLoginForm;
